<template>
    <div>
        <div class="show-destop">
            <header id="header" class="navbar navbar-dark sticky-top flex-md-nowrap">
                <a id="logo-link" class="navbar-brand col-md-3 col-lg-2 me-0" href="/">
                    <img id="logo-1" src="/themes/web/assets/images/logo.png" alt="" />
                </a>
            </header>
            <link rel="stylesheet" href="/themes/web/assets/css/auth.css?v=3" />

            <div id="wrapper" class="wrapper d-flex align-items-stretch">
                <!--<side-bar/>-->
                <div id="content">
                    <div class="row" style="line-height: initial !important; ">
                        <div class="col">
                            <div style="font-size: 40px; font-weight:700">Thông báo nâng cấp hệ thống</div>
                            <div class="text_class">
                                Từ ngày 15/8/2023, hệ thống LISA đã được nâng cấp thành hệ thống <span
                                    style="font-weight: 700;font-size: larger;">iPRO2</span>.<br>
                                Quý Phụ huynh và các em Học sinh sẽ được tự động điều chuyển đến địa chỉ:
                                <span style="font-weight: 700;font-size: larger;">https://ipro2.ismart.edu.vn/</span> hoặc
                                nhấn vào nút bên dưới để đi tới trang.
                                <br>
                                <br>
                            </div>
                            <div style="font-size: 40px; font-weight:700">System upgrade notification</div>
                            <div style="font-size: 20px">
                                Starting from August 15th, 2023, the LISA system has been upgraded to the
                                <span style="font-weight: 700;font-size: larger;">iPRO2</span> system. <br>Parents and
                                students will be automatically redirected to the
                                address: <span
                                    style="font-weight: 700;font-size: larger;">https://ipro2.ismart.edu.vn/</span> or you
                                can click the button below to
                                go to the page.
                            </div>
                            <div class="" style="margin-top: 20px;display: flex;align-items: center;">
                                <a ref="aLink" href="https://ipro2.ismart.edu.vn/"><img id="logo-a" style="width: 174px;"
                                        src="/themes/web/assets/images/lisa_down.png" alt="" /></a>
                                <span style="margin-left: 20px; font-size: 30px;">{{ countDown }}</span> 
                            </div>
                        </div>
                        <div class="col-5">
                            <div>
                                <img id="logo-n" style="width: 500px" src="/themes/web/assets/images/logo_new.png" alt="" />
                            </div>
                            <div style="font-size: 30px; text-align:center">Download application</div>
                            <div class="row">
                                <div class="col" style="text-align:right">
                                    <img id="logo-a" style="width: 135px;" src="/themes/web/assets/images/lisa_android.png"
                                        alt="" />
                                </div>
                                <div class="col" style="text-align:left">
                                    <img id="logo-a" style="width: 135px;" src="/themes/web/assets/images/lisa_ios.png"
                                        alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer-element />
        </div>
    </div>
</template>

<script>
import FooterElement from "../FooterElement";
export default {
    name: "LandingPageLisa",
    data() {
        return {
            countDown: 10
        };
    },
    created() {
        let interval = setInterval(() => {
            if (this.countDown == 0) {
                clearInterval(interval)
                this.$refs.aLink.click()
               
            } else {
                this.countDown--
            }
        }, 1000)

    },
    components: {
        FooterElement,
    },

    computed: {},

    methods: {

    },
};
</script>
<style scoped>
.header-search-form input {
    box-shadow: none;
    border: 1px solid #ccd2e3;
}

.dropdown-item.upgrade {
    padding: 10px 22px !important;
}

.icon-upgrade {
    width: 23px;
    line-height: 18px;
    /* background-image: url(/public/themes/ito/images/icon-upgrade.svg);
        background-position: 0px 0px;
        background-repeat: no-repeat;
        display: inline-block;
        vertical-align: sub; */
}

.nav-link.dropdown-toggle {
    padding: 0 !important;
}

.btn.btn-htool {
    display: flex;
    align-items: center;
    height: 44px;
    border: 1px solid #ccd2e3;
    box-shadow: none;
}

.btn.btn-htool .label {
    height: 100%;
    color: #1f4083;
    margin-left: 4px;
}

.btn.btn-htool.save-account {
    padding: 11px 12px;
    font-weight: 700;
    background: linear-gradient(180deg, #40c0f6 0%, #28b5f0 100%);
    box-shadow: 4px 2px 20px rgba(0, 0, 0, 0.07);
    border-radius: 8px;
}

.btn.btn-htool.save-account .label {
    margin-left: 10px;
}

.lisa-icon-header-grade {
    width: 31px;
}

.btn.btn-help {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 135px;
}

.lisa-icon-header-help {
    font-weight: 700;
}

.header-help {
    width: 135px;
}

#logo-link {
    width: 135px;
}

#logo-1 {
    /* height: 115px; */
    width: 100%;
}

.header-content .header-avatar-body>.header-avatar .thumb img.avatar {
    border-radius: 8px;
}

/* @media (max-width: 1400px) {
        .header-content{
            width: 942px;
            margin-left: 45px;
        }
    } */
.dropdown-menu li a {
    color: #212529;
}

.dropdown {
    cursor: pointer;
}

.dropdown:hover .dropdown-menu {
    display: block;
}

.lisa-icon-search-close {
    top: 15px !important;
    margin: 0;
    cursor: pointer;
}

.text_class {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 27px;
    letter-spacing: 0.02em;
}
</style>
